/* @flow */

import * as React from 'react';
import styled from 'styled-components';

const Shallow = styled.span`
  opacity: ${({ theme }) => theme.shallowDigitOpacity};
`;

export type Props = {
  digit: number,
  value: string,
  preValue?: number | string | boolean,
};

export default
class ShallowDigit extends React.PureComponent<Props> {
  static defaultProps = {
    preValue: null,
  }

  static defaultProps = { preValue: '' }

  render() {
    const {
      digit,
      value,
      preValue,
    } = this.props;


    if (!preValue) return value;
    if (Number.isNaN(Number(preValue))) return value;

    const strValue = Number(value).toFixed(digit);
    const strPreValue = Number(preValue).toFixed(digit);

    if (strValue.substring(0, strValue.length - 2) ===
      strPreValue.substring(0, strValue.length - 2)) {
      return (
        <span>
          <Shallow>

            { strValue.substring(0, strValue.length - 2) }
          </Shallow>
          { strValue.substr(strValue.length - 2, 2)}
        </span>);
    }
    return value;
  }
}
